import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import { mapToClientRect } from './geometry';

var IntersectionObserverEntry = /*#__PURE__*/_createClass(
/**
 * Creates new instance of IntersectionObserverEntry.
 *
 * @param {Element} target
 * @param {ClientRect} targetRect
 * @param {ClientRect} intersecRect
 * @param {Number} intersecRatio
 * @param {ClientRect} rootBounds
 * @param {Timestamp} time
 */
function IntersectionObserverEntry(target, targetRect, intersecRect, intersecRatio, rootBounds, time) {
  _classCallCheck(this, IntersectionObserverEntry);

  // According to the spec following properties are not writable and
  // in native implementation they are also not enumerable.
  Object.defineProperties(this, {
    boundingClientRect: {
      value: targetRect
    },
    intersectionRatio: {
      value: intersecRatio
    },
    intersectionRect: {
      value: mapToClientRect(intersecRect)
    },
    rootBounds: {
      value: mapToClientRect(rootBounds)
    },
    target: {
      value: target
    },
    time: {
      value: time
    }
  });
});

export { IntersectionObserverEntry as default };